import { render, staticRenderFns } from "./SellerOfferBiddingDetails.vue?vue&type=template&id=0487a7b2&scoped=true"
import script from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"
export * from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487a7b2",
  null
  
)

export default component.exports